@file:Suppress("MagicNumber")

package top.wcpe.allincore.ui.runtime.event

import top.wcpe.allincore.ui.runtime.element.ChildOrigin
import top.wcpe.allincore.ui.runtime.element.UIElement
import kotlin.jvm.JvmStatic

/**
 * 命中测试与控件交互共用的几何工具：子节点遍历起点 X/Y 推算、变换后包围盒缩放分量提取。
 *
 * 子节点起点规则统一委托 [ChildOrigin]；命中口径须与 UIRenderer 渲染口径一致。
 */
internal object HitGeometry {

    /** 计算容器子节点遍历起点 X。规则详见 [ChildOrigin.x]。 */
    @JvmStatic
    fun childOriginX(node: UIElement<*>, absX: Float): Float = ChildOrigin.x(node, absX)

    /** 计算容器子节点遍历起点 Y。规则详见 [ChildOrigin.y]。 */
    @JvmStatic
    fun childOriginY(node: UIElement<*>, absY: Float): Float = ChildOrigin.y(node, absY)

    /** 从 Transform2D.transformedBox 返回的扩展数组中读取 Y 缩放分量；缺省视为 1。 */
    @JvmStatic
    fun scaleY(box: FloatArray): Float = if (box.size > 5) box[5] else 1f
}
